import React, { Component, Fragment } from "react";
import AppLayout from "./layouts/AppLayout/AppLayout";
import Scene from "./layouts/AppLayout/Scene/Scene";
import SidebarContent from "./shared/SidebarContent/SidebarContent";
import { observer, inject } from "mobx-react";
import "../styles/styles.scss";
import sceneImagesMap from "../assets/data/sceneImagesMap";
import iconsMaps from "../assets/data/iconsMaps";
import Cover from "../components/shared/Cover/Cover"
import setup from "../setup/setup"

@inject("SceneStore", "AppStore")
@observer
class App extends Component {
  state = {
    start: false,
    zoom: false
  };

  componentDidMount() {
    const sceneImagesMapArr = Object.values(sceneImagesMap);
    const iconsMapsArr = Object.values(iconsMaps);
    sceneImagesMapArr.forEach(picture => {
      const img = new Image();
      img.src = picture;
    });
    iconsMapsArr.forEach(picture => {
      const img = new Image();
      img.src = picture;
    });
  }

  startApp = () => {
    this.setState({ start: true })
  }

  onZoom = () => {
    this.setState({ zoom: !this.state.zoom })
  }

  render() {
    const { SceneStore, AppStore } = this.props;
    const appConfig = AppStore.getAppConfig;
    const {
      getSceneSetting: sceneSetting,
      getSortedDynamicLevels: dinamycLevels,
      getSortedDefaultLevels: defaultLevels,
      currentSubStepInfo,
      currentSubStepConfiguration,
      currentSubStepName,
      currentSubStepSelectedAtom,
      getStepConfiguration
    } = SceneStore;

    return (
      <Fragment>
        {
          this.state.start &&
          <AppLayout
            currentSubStepName={currentSubStepName}
            appConfig={appConfig}
            sceneSetting={sceneSetting}
            zoom={ this.state.zoom }
            resetScene={() => SceneStore.resetScene()}
            sidebarContent={
              <SidebarContent
                checkEnabledLevel={(atom, type) =>
                  SceneStore.checkEnabledLevel(atom, type)
                }
                getIconImage={alias => SceneStore.getIconImage(alias)}
                currentSubStepSelectedAtom={currentSubStepSelectedAtom}
                onAtomSelect={(atom, type, link) =>
                  SceneStore.onAtomSelect(atom, type, link)
                }
                currentSubStepConfiguration={currentSubStepConfiguration}
                currentSubStepInfo={currentSubStepInfo}
              />
            }
            onStepChange={(type, stepId) => SceneStore.changeStep(type, stepId)}
          >
            <Scene
              getItemByAlias={(alias) => SceneStore.getItemByAlias(alias)}
              onZoom={(type => this.onZoom(type))}
              getStepConfiguration={alias => getStepConfiguration(alias)}
              getSceneImages={alias => SceneStore.getSceneImages(alias)}
              dinamycLevels={dinamycLevels}
              defaultLevels={defaultLevels}
              sceneSetting={sceneSetting}
            />
          </AppLayout>
        }
        {
          !this.state.start &&
          <Cover startApp={() => this.startApp()}/>
        }
      </Fragment>
    );
  }
}

export default App;
